import React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faLayerGroup, 
  faCalendar, 
  faArrowRight, 
  faCheckCircle, 
  faPlayCircle 
} from "@fortawesome/free-solid-svg-icons";
import { useToasts } from "react-toast-notifications";
import CourseService from "services/CourseService";
import Button from "components/CustomButton";
import { truncateText } from "utils/helpers";

const UserCourseCard = ({ course, teamId, progress, status }) => {
  const history = useHistory();
  const { addToast } = useToasts();

  const getStatusClass = (status) => {
    switch (status) {
      case "Completed":
        return "success";
      case "In Progress":
        return "warning";
      default:
        return "secondary";
    }
  };

  // Handle taking a course
  const handleTakeCourse = (courseId) => {
    CourseService.startCourse(courseId, teamId)
      .then(() => {
        history.push(`/teams/${teamId}/courses/${courseId}/view`);
      })
      .catch(error => {
        console.error("Error starting course:", error);
        addToast("Failed to start the course", { appearance: "error" });
      });
  };

  return (
    <div className="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-6 mb-4">
      <div className="card h-100 d-flex flex-column course-list-card">
        <div className="course-card-cover position-relative" style={{
          height: '180px', 
          background: '#f5f5f5', 
          borderTopLeftRadius: '6px', 
          borderTopRightRadius: '6px', 
          overflow: 'hidden',
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center'
        }}>
          {course.thumbnail ? (
            <img 
              src={course.thumbnail} 
              alt={course.title} 
              style={{width: '100%', height: '100%', objectFit: 'cover'}}
            />
          ) : (
            <img 
              src="https://images.pexels.com/photos/4050315/pexels-photo-4050315.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
              alt="Course Cover" 
              style={{width: '100%', height: '100%', objectFit: 'cover'}}
            />
          )}
          <span className={`course-status-pill badge bg-${getStatusClass(status)} position-absolute top-0 end-0 m-2`}>{status?.charAt(0).toUpperCase() + status?.slice(1)}</span>
        </div>
        
        <div className="card-body flex-grow-1 d-flex flex-column">
          <h5 className="card-title mb-1 text-truncate"><strong>{course.title}</strong></h5>
          <p className="card-text text-muted mb-2">{truncateText(course.description, 200)}</p>
          
          <div className="d-flex align-items-center mb-2 gap-3">
            <span className="d-flex align-items-center">
              <FontAwesomeIcon icon={faLayerGroup} className="me-1 text-primary" />
              <small className="text-muted">
                {course.modules.length} {course.modules.length === 1 ? 'module' : 'modules'}
              </small>
            </span>
            <span className="d-flex align-items-center">
              <FontAwesomeIcon icon={faCalendar} className="me-1 text-secondary" />
              <small className="text-muted">
                {course.createdAt ? moment(course.createdAt).format("MMM DD, YYYY") : ''}
              </small>
            </span>
          </div>
          
          {progress > 0 && (
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <small>Progress</small>
                <small>{progress}%</small>
              </div>
              <div className="progress" style={{ height: "6px" }}>
                <div 
                  className="progress-bar bg-success" 
                  role="progressbar" 
                  style={{ width: `${progress}%` }} 
                  aria-valuenow={progress} 
                  aria-valuemin="0" 
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          )}
          
          <div className="d-flex align-items-center mt-auto gap-2">                          
            <Button 
              buttonClass={`btn ${status === "Completed" ? "btn-outline-success" : "btn-primary"} ms-auto w-100`}
              onClick={() => handleTakeCourse(course.id)}
            >
              {status === "Not Started" && (
                <>
                  <FontAwesomeIcon icon={faPlayCircle} className="me-2" />
                  Start
                </>
              )}
              {status === "In Progress" && (
                <>
                  <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                  Resume
                </>
              )}
              {status === "Completed" && (
                <>
                  <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                  Review
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCourseCard; 